import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'
import Isvg from 'react-inlinesvg'

import extendedIcon from 'assets/components/navigation_menu_list/extended_icon.svg'

import styles from './navigation_menu_list.scss'

const NavigationMenuList = props => (
	<ul styleName='list'>
		{ props.items.map(item => (
			<li
				key={item.id}
				styleName={classNames({
					'list-item': true,
					'list-item--highlighted': item.isHighlighted,
				})}
				onClick={() => props.onSelect(item.id)}
			>
				<Isvg
					styleName='list-item-icon'
					src={item.icon}
					cacheGetRequests={true}
				/>
				<span styleName='list-item-text'>
					{item.label}
				</span>
				{ item.isExtended &&
					<Isvg
						styleName='list-item-extended-icon'
						src={extendedIcon}
						cacheGetRequests={true}
					/>
				}
			</li>
		))}
	</ul>
)

NavigationMenuList.propTypes = {
	items: PropTypes.array,
	onSelect: PropTypes.func,
}

NavigationMenuList.defaultProps = {
	items: [],
	onSelect: () => {},
}

export default CSSModules(NavigationMenuList, styles, {allowMultiple: true})
